import { type FC, useMemo } from 'react'

import { useParams } from '@tanstack/react-router'

import { useRegion } from '@/state/regions/useRegion'

import { PromotionCreateFormPage } from './PromotionCreateFormPage'

export interface RegionPromotionCreateFormPageProps {
  onDirtyChange?: (isDirty: boolean) => void
}

export const RegionPromotionCreateFormPage: FC<RegionPromotionCreateFormPageProps> = ({ onDirtyChange }) => {
  const { initiativeId, regionId } = useParams({ from: '/promotions/$initiativeId/$regionId/create' })
  const { data: region } = useRegion({ regionId })
  const enabledPlacements = useMemo(
    () => Object.fromEntries(region?.promotionPlacements?.[initiativeId]?.map((placement) => [placement, true]) ?? []),
    [initiativeId, region?.promotionPlacements]
  )

  return (
    <PromotionCreateFormPage
      initiativeId={initiativeId}
      regionId={regionId}
      enabledPlacements={enabledPlacements}
      metadata={{ initiativeId, regionId, type: 'local' }}
      type="local"
      onDirtyChange={onDirtyChange}
    />
  )
}
